import { LatLngTuple } from "leaflet";

export const DEFAULTS = {
  initial_location: [61.2299209, 7.1014066] as LatLngTuple,
  initial_zoom: 11,
  map_style: "https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
  marker_icon: "/images/marker.svg",
};
